import styled, { css } from "styled-components";

const commonCss = css`
    position: relative;
    width: 720px;
    height: 405px;
    ${p =>
        p.theme.xs(css`
            width: calc(100vw - 32px);
            height: calc((100vw - 32px) * (720 / 1280));
        `)}
`;

export const OuterWrapper = styled.div`
    ${commonCss}
    padding-bottom: 38px;
    margin-top: 20px;
`;

export const InnerWrapper = styled.div`
    ${commonCss}
`;
